// extracted by mini-css-extract-plugin
export var active = "search-module--active--35bd2";
export var breadcrumbs = "search-module--breadcrumbs--8ba60";
export var container = "search-module--container--eaabd";
export var header = "search-module--header--10413";
export var httpMethod = "search-module--httpMethod--9083e";
export var method = "search-module--method--ff1db";
export var pageSectionName = "search-module--pageSectionName--69447";
export var paramDataType = "search-module--paramDataType--e3f44";
export var paramDetails = "search-module--paramDetails--fe7e8";
export var paramMethod = "search-module--paramMethod--ef877";
export var paramName = "search-module--paramName--bb327";
export var paramOpt = "search-module--paramOpt--878c2";
export var paramReq = "search-module--paramReq--56d27";
export var resultContentContainer = "search-module--resultContentContainer--3049d";
export var resultItem = "search-module--resultItem--844b9";
export var resultItemBody = "search-module--resultItemBody--938f0";
export var resultItemHeader = "search-module--resultItemHeader--550d0";
export var resultItemHeaderParams = "search-module--resultItemHeaderParams--524c9";
export var results = "search-module--results--eb506";
export var resultsCounter = "search-module--resultsCounter--f18d3";
export var searchBtn = "search-module--searchBtn--83089";
export var searchTab = "search-module--searchTab--86740";
export var sectionDetails = "search-module--sectionDetails--15c18";
export var sectionIcon = "search-module--sectionIcon--46f64";
export var sectionIconInResult = "search-module--sectionIconInResult--63063";
export var tabs = "search-module--tabs--b4c6f";